import { Link, useParams } from "react-router-dom";
import { EmptyState } from "../components/EmptyState";
import { JewelleryMotif } from "../components/JewelleryMotif";
import { ProductTile } from "../components/ProductTile";
import { Seo } from "../components/Seo";
import { getCollection } from "../data/collections";
import { productsInCollection } from "../data/products";

export function CollectionPage() {
  const { slug = "" } = useParams();
  const collection = getCollection(slug);
  const pieces = productsInCollection(slug);

  if (!collection) {
    return (
      <main id="main" className="page">
        <Seo title="Collection not found" path={`/collections/${slug}`} />
        <EmptyState title="Collection not found">
          That collection is not listed.
        </EmptyState>
        <p>
          <Link to="/collections">Back to collections</Link>
        </p>
      </main>
    );
  }

  return (
    <main id="main" className="page">
      <Seo
        title={collection.name}
        description={collection.intro}
        path={`/collections/${collection.slug}`}
      />
      <p className="kicker">Coming soon</p>
      <h1>{collection.name}</h1>
      <p className="lede">{collection.intro}</p>
      {pieces.length === 0 ? (
        <div className="coming-soon-stage section">
          <div className="product-stage">
            <JewelleryMotif motif={collection.motif} title={collection.name} />
          </div>
          <div>
            <span className="coming-soon-flag">Coming soon</span>
            <p>This collection is on its way.</p>
            <p className="quiet-note">Shopping is not available yet.</p>
            <p>
              <Link to="/collections">See all collections</Link>
            </p>
          </div>
        </div>
      ) : (
        <div className="product-grid section">
          {pieces.map((product) => (
            <ProductTile key={product.id} product={product} />
          ))}
        </div>
      )}
    </main>
  );
}
